
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { createEventRequest, createEventRequestError, createEventRequestSuccess } from "../../slices/event-management/CreateEventSlice";

export const CreateEventAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(createEventRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.createEvent,
                data: data,
            })
            return dispatch(createEventRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(createEventRequestError(_error));
        }
    };
